module.exports = __webpack_public_path__ + "static/media/expert.190a244f.svg";